import * as _ from "lodash";
import { TeamColorDataProvider } from "../data-provider/team-color.dp";
import { Team } from "./team.model";

export class Invite {
    public readonly requestIgnoreList = ["teamColorDataProvider"];
    private teamColorDataProvider: TeamColorDataProvider;
    public images: any = null;
    public campaigninviteemail: null | string = null;
    public initials: null | string = null;
    public campaigninvitephonenumber: null | string = null;
    public campaigninviteid: null | number = null;
    public campaignid: null | number = null;
    public campaigninvitecountrycode: null | string = null;
    public campaigninvitesender: null | number = null;
    public campaigninvitestatusid: null | number = null;
    public campaigninvitetimestamp: null | string = null;
    public permissionid: null | number = null;
    public deliverystatus: string | null = null;
    public deliverytimestamp: null | string = null;
    public previously_rejected?: boolean;
    public sms: { deliverystatus: null | string };

    public team?: Team;
    public teams?: Team[];
    public seated?: string;
    public checked?: boolean;
    public license_type?: string;

    constructor(
        TeamColorDataProvider: TeamColorDataProvider,
        inviteData?: object
    ) {
        this.teamColorDataProvider = TeamColorDataProvider;
        this.setData(inviteData);
    }

    getID(): string | number | null {
        return this.campaigninviteid;
    }

    isPendingApproval(): boolean {
        return Number(this.campaigninvitestatusid) === 5;
    }

    setData(inviteData?: object): void {
        if (inviteData) {
            _.merge(this, inviteData);
        }
        this.getImage();
        if (this.permissionid) {
            if ([2, 3, 4, 8, 9, 10].includes(this.permissionid)) {
                this.license_type = "super";
            } else {
                this.license_type = "standard";
            }
        }
    }

    getImage(): void {
        let color =
            this.teamColorDataProvider.teamColours[
                this.campaigninviteid %
                    this.teamColorDataProvider.teamColours.length
            ]; //gets a semi random color from colors array, that should always stay the same for same invite
        this.images = {};
        if (this.campaigninviteemail) {
            this.initials =
                "https://eu.ui-avatars.com/api/?name=" +
                this.campaigninviteemail +
                "&background=" +
                color.substr(1) +
                "&color=fff&rounded=true&bold=true&length=1";
        } else {
            this.initials =
                "https://eu.ui-avatars.com/api/?name=" +
                this.campaigninvitephonenumber +
                "&background=" +
                color.substr(1) +
                "&color=fff&rounded=true&bold=true&length=1";
        }
        this.images.small = this.initials + "&size=64";
        this.images.medium = this.initials + "&size=128";
        this.images.big = this.initials + "&size=256";
    }
}
